export default {
  nicknameAuthenticated: null,
  profiles: {},
  username: null,
  me: {},
};
